import { FetchPolicy } from 'apollo-client';
import { client } from '..';
import gql from 'graphql-tag';

export interface FeatureLayoutParams {
    layoutId: number;
    dashboardPanelId?: string | null;
    userGuid?: string;
    accessedFromDashboard?: boolean;
}

export interface FeatureLayoutListData {
    loading?: boolean;
    networkStatus?: number;
    featureLayoutList: FeatureLayoutList;
}

export interface FeatureLayoutList {
    recordCount: number;
    featureLayout: FeatureLayout[];
}

export interface FeatureLayout {
    id: number;
    guidId: string;
    featureGuid: string;
    feature: string;
    description: string;
    sequence: number;
    title: string;
    infoUrl: string;
    aiPrompt: string | null; 
}

export function fetchDashboardData(
    query: FeatureLayoutParams,
    refreshData: boolean,
    onSuccess: (data: FeatureLayoutListData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void,
): void {
    var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';

    client
        .query({
            query: FEATURE_LAYOUT_QUERY,
            variables: {
                layoutId: query.layoutId, // Hard coded for now.
                dashboardPanelId: query.dashboardPanelId,
                accessedFromDashboard: query.accessedFromDashboard
            },
            fetchPolicy: fetchPolicy,
        })
        // tslint:disable-next-line:no-any
        .then((results: { data: any }) => {
            onSuccess(results.data);
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            onError(reason);
        });
}

export const FEATURE_LAYOUT_QUERY = gql`
    query featureLayoutData($layoutId: Int, $dashboardPanelId: String, $userGuid: String, $accessedFromDashboard: Boolean) {
        featureLayoutList(layoutId: $layoutId, dashboardPanelId: $dashboardPanelId, userGuid: $userGuid, accessedFromDashboard: $accessedFromDashboard) {
            recordCount
            featureLayout {
                guidId
                featureGuid
                feature
                description
                sequence
                title
                infoUrl
                aiPrompt
            }
        }
    }
`;
